import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ToastMessage} from "./toast-models";
import {Subscription} from "rxjs";
import {ToastService} from "./toast-service";
import {NgClass, NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-toast-wrapper',
  imports: [
    NgClass,
    NgForOf,
    NgIf
  ],
  templateUrl: './toast-wrapper.component.html',
  styleUrl: './toast-wrapper.component.scss'
})
export class ToastWrapperComponent implements OnInit, OnDestroy {
  toasts: ToastMessage[] = [];
  private timers = new Map<string, ReturnType<typeof setTimeout>>();
  private subscription!: Subscription;
  toastService = inject(ToastService);

  ngOnInit(): void {
    this.subscription = this.toastService.toasts$.subscribe(toasts => {
      this.toasts = toasts;
      toasts.forEach(t => this.startTimer(t));
    });
  }

  private startTimer(toast: ToastMessage): void {
    if (this.timers.has(toast.id)) return;

    const timer = setTimeout(() => {
      this.toastService.remove(toast.id);
      this.timers.delete(toast.id);
    }, toast.options.duration);

    this.timers.set(toast.id, timer);
  }

  pauseTimer(id: string): void {
    const timer = this.timers.get(id);
    if (!timer) return;
    clearTimeout(timer);
    this.timers.delete(id);
  }

  resumeTimer(toast: ToastMessage): void {
    if (!toast.options.keepOnHover) return;
    this.startTimer(toast);
  }

  close(id: string): void {
    this.toastService.remove(id);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.timers.forEach(clearTimeout);
    this.timers.clear();
  }
}
